<template>
  <details class="ecom details">
    <summary class="ecom details__summary">
      <slot name="icon" class="ecom details__icon"></slot>
      <slot name="header"></slot>
      <img class="ecom details__arrow" :src="chevron" />
    </summary>
    <slot name="content"></slot>
  </details>
</template>

<script>
import config from '@/config'

const { cdn } = config
export default {
  data () {
    return {
      chevron: `${cdn}chevron-icon.svg`
    }
  }
}
</script>
